// theme constant
export const gridSpacing = 3;
export const drawerWidth = 260;
export const appDrawerWidth = 320;

export const UNEXPECTED_RESPONSE_STATUS = 'Unexpected response status';
export const SOMETHING_WENT_WRONG = { success: false, error: 'Something went wrong' }
